import { gsap, Power3, Power2 } from "gsap";

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Default from './Default';
import Header from '../layout/Header';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import NoScroll from './NoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Maths } from "../_app/cuchillo/utils/Maths";
import { Basics, isDebug, isMobile, isSafari, isSmartphone } from "../_app/cuchillo/core/Basics";
import Wrap from "../layout/Wrap";
import Preloader from "../layout/Preloader";

export default class Home extends NoScroll {
  sliderLeft;
  scrollerLeft;
  sliderRight;
  scrollerRight;
  sliderMobile;
  scrollerMobile;

  itemsLeft = [];
  itemsRight = [];
  descriptionLeft = [];
  descriptionsRight = [];

  looping = false;

  _calls = {
    enter: (e) => {
      document.body.classList.add(e.target.dataset.name);
      const current = GetBy.selector(`.__project-card[data-index="${e.target.dataset.index}"]`)[0];
      current.classList.add('--current');
    },
    leave: (e) => {
      document.body.classList.remove(e.target.dataset.name);
      const current = GetBy.selector(`.__project-card[data-index="${e.target.dataset.index}"]`)[0];
      current.classList.remove('--current');
    }
  };

  constructor() {
    super();

    document.body.classList.add('--home');

    if (!isMobile) {
      this.sliderLeft = GetBy.class('__slider', this.container)[0];
      this.scrollerLeft = new InfiniteScroll(InfiniteScroll.AXIS_Y, {
        domResize: this.sliderLeft,
        container: this.sliderLeft,
        multiplicator: 1.3,
        itemClass: InfiniteScroll__Item,
        minSpeed: 0,
        inverted: false,
        gap: 0,
        hasVirtuaScroll: true
      });
      this.itemsLeft = GetBy.selector('.__item .wrapper', this.sliderLeft);
      this.descriptionsLeft = [...GetBy.selector('.__project-card.--card-vicio')];

      this.sliderRight = GetBy.class('__slider', this.container)[1];
      this.scrollerRight = new InfiniteScroll(InfiniteScroll.AXIS_Y, {
        domResize: this.sliderRight,
        container: this.sliderRight,
        multiplicator: 1.3,
        itemClass: InfiniteScroll__Item,
        minSpeed: 0,
        inverted: false,
        gap: 0,
        hasVirtuaScroll: true
      });
      this.itemsRight = GetBy.selector('.__item.wrapper', this.sliderRight);
      this.descriptionsRight = [...GetBy.selector('.__project-card.--card-brunch')];

      for (let i = 0; i < this.itemsLeft.length; i++) {
        const element = this.itemsLeft[i];
        element.addEventListener('mouseenter', this._calls.enter);
        element.addEventListener('mouseleave', this._calls.leave);
      }
      for (let i = 0; i < this.itemsRight.length; i++) {
        const element = this.itemsRight[i];
        element.addEventListener('mouseenter', this._calls.enter);
        element.addEventListener('mouseleave', this._calls.leave);
      }
    } else {
      this.sliderMobile = GetBy.class('__slider', this.container)[0];
      this.scrollerMobile = new InfiniteScroll(InfiniteScroll.AXIS_Y, {
        domResize: this.sliderMobile,
        container: this.sliderMobile,
        multiplicator: 1,
        itemClass: InfiniteScroll__Item,
        minSpeed: 0,
        inverted: false,
        gap: 0,
        hasVirtuaScroll: true
      });
      this.itemsMobile = GetBy.selector('.__item', this.sliderMobile);
    }
  }

  beforeShow() {
    super.beforeShow();

    if (this.isFirstTime) {
      if (this.scrollerLeft) this.scrollerLeft.directGoto(5);
      if (this.scrollerRight) this.scrollerRight.directGoto(3);
      if (this.scrollerMobile) this.scrollerMobile.directGoto(3);
    }
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Header.show(() => {
          if (this.scrollerLeft) this.scrollerLeft.goto(0);
          if (this.scrollerRight) this.scrollerRight.goto(0);
          if (this.scrollerMobile) this.scrollerMobile.goto(0);

          Preloader.hide(() => { this.afterShow() });
        });
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }
  }

  afterShow() {
    this._isActive = true;

    Scroll.show();

    if (this.scrollerLeft) {
      this.scrollerLeft.show();
      this.scrollerLeft.start();
    }

    if (this.scrollerRight) {
      this.scrollerRight.show();
      this.scrollerRight.start();
    }

    if (this.scrollerMobile) {
      this.scrollerMobile.show();
      this.scrollerMobile.start();
    }
  }

  beforeHide() {
    super.beforeHide();

    if (this.scrollerLeft) {
      this.scrollerLeft.hide();
      this.scrollerLeft.stop();
    }

    if (this.scrollerRight) {
      this.scrollerRight.hide();
      this.scrollerRight.stop();
    }

    if (this.scrollerMobile) {
      this.scrollerMobile.hide();
      this.scrollerMobile.stop();
    }
  }

  afterHide() {
    super.afterHide();

    document.body.classList.remove('--home');

    for (let i = 0; i < this.itemsLeft.length; i++) {
      const element = this.itemsLeft[i];
      element.removeEventListener('mouseenter', this._calls.enter);
      element.removeEventListener('mouseleave', this._calls.leave);
    }
    for (let i = 0; i < this.itemsRight.length; i++) {
      const element = this.itemsRight[i];
      element.removeEventListener('mouseenter', this._calls.enter);
      element.removeEventListener('mouseleave', this._calls.leave);
    }
  }

  loop() {
    super.loop();

    if (this.scrollerLeft) this.scrollerLeft.loop();
    if (this.scrollerRight) this.scrollerRight.loop();

    if (this.scrollerMobile && this._isActive) {
      this.scrollerMobile.loop();

      document.body.classList.remove('--vicio');
      document.body.classList.remove('--brunch');

      for (let i = 0; i < this.itemsMobile.length; i++) {
        const element = this.itemsMobile[i];
        if (i === this.scrollerMobile.current) {
          document.body.classList.add(element.dataset.name);
        }
      }
    }
  }

  dispose() {
    if (this.scrollerLeft) this.scrollerLeft.dispose();
    if (this.scrollerRight) this.scrollerRight.dispose();
    if (this.scrollerMobile) this.scrollerMobile.dispose();

    super.dispose();
  }

  resize(__w, __h) {
    super.resize(__w, __h);

    if (this.scrollerLeft) this.scrollerLeft.resize();
    if (this.scrollerRight) this.scrollerRight.resize();
    if (this.scrollerMobile) this.scrollerMobile.resize();
  }
}

ControllerPage._addPage('home', Home);
